export default {
  'error.csrf_reload_required':
    'This page is no longer valid. Reload the page and try again.',
  'error.too_many_requests': 'Too many requests. Please try again later.',
  'page_reset_password.title': 'Reset Password',
  'page_reset_password.description': 'Enter your new password to reset it',
  'page_reset_password.form_password': 'Passsword',
  'page_reset_password.form_password_confirmation': 'Password confirmation',
  'page_reset_password.toast_successful_title':
    'Your password has been reset successfully.',
  'page_reset_password.toast_successful_description': 'Now you can login.',
  'page_reset_password.form_schema_min_1_password': 'Password is required',
  'page_reset_password.form_schema_min_8_password':
    'Password must be at least 8 characters long',
  'page_reset_password.form_schema_strong_password':
    'Password not strong enough',
  'page_reset_password.form_schema_match_password': "Passwords don't match.",
  'page_setup_password.title': 'Setup Password',
  'page_setup_password.description': 'Please create your new password',
  'page_setup_password.form_password': 'Password',
  'page_setup_password.form_current_password': 'Temporary password',
  'page_setup_password.form_password_confirmation': 'Password confirmation',
  'page_setup_password.form_email': 'Email',
  'page_setup_password.toast_successful_title':
    'Your password has been setup successfully.',
  'page_setup_password.toast_successful_description':
    'Now you can start using the portal.',
  'page_setup_password.submitting': 'Submitting...',
  'page_setup_password.server_error':
    'Failed to set password. Please try again.',
  'page_setup_password.form_schema_min_1_password': 'Password is required',
  'page_setup_password.form_schema_min_8_password':
    'Password must be at least 8 characters long',
  'page_setup_password.form_schema_strong_password':
    'Password not strong enough',
  'page_setup_password.form_schema_match_password': "Passwords don't match.",
  'page_change_password.title': 'Change Password',
  'page_set_password.title': 'Set Password',
  'page_change_password.description': 'This is where you change your password',
  'page_set_password.description': 'This is where you set your password',
  'page_change_password.form_current_password': 'Current Passsword',
  'page_change_password.form_new_password': 'New Passsword',
  'page_change_password.form_new_password_confirmation':
    'New Password Confirmation',
  'page_change_password.error.current_password_invalid':
    'The current password is incorrect.',
  'page_change_password.error.required_field':
    'Please fill in the {{field}} field.',
  'page_change_password.error.required': 'Please fill in the required fields.',
  'page_change_password.error.confirmed':
    'The new password confirmation does not match.',
  'page_change_password.error.new_password_min':
    'The new password is too short.',
  'page_change_password.error.validation': 'Please check the password fields.',
  'page_change_password.error.generic': 'Failed to change password.',
  'page_change_password.toast_successful_title':
    'Your password has been changed successfully.',
  'page_set_password.toast_successful_title':
    'Your password has been set successfully.',
  'page_email_notification.title': 'Email Notifications',
  'page_email_notification.new_bookings': 'New Bookings',
  'page_email_notification.booking_updates': 'Booking Updates',
  'page_email_notification.toast_successful_title':
    'Notifications updated successfully.',
  'page_credit.title': 'Credit',
  'page_credit.description':
    'Buy credits to create more vacancies and reach more candidates.',
  'page_credit.form_credit': 'Credit Amount',
  'page_credit.placeholder': 'Enter a credit amount',
  'page_credit.form_schema_required_credit': 'Credit amount is required',
  'page_credit.form_schema_numeric_credit': 'Credit amount must be a number',
  'page_credit.form_schema_min_1_credit': 'Credit amount must be at least 1',
  'button.purchase': 'Purchase',
  'button.purchasing': 'Purchasing',
  'page_credit.current_credits': 'Current credits',
  'page_credit.total': 'Total',
  'page_credit.choose_amount_below': 'Choose your amount below.',
  'page_users_overview.title': 'Customers',
  'page_reports_overview.title': 'Reports',
  'page_reports_overview.id': 'ID',
  'page_reports_overview.customer': 'Customer',
  'page_reports_overview.email': 'Email',
  'page_reports_overview.report_name': 'Report name',
  'page_reports_overview.period': 'Period',
  'page_reports_overview.progress': 'Progress',
  'page_reports_overview.status': 'Status',
  'page_reports_overview.status_in_progress': 'In Progress',
  'page_reports_overview.status_completed': 'Completed',
  'page_reports_overview.trigger_type': 'Trigger Type',
  'page_reports_overview.triggered_at': 'Triggered At',
  'page_reports_overview.export': 'Generate Reports',
  'page_reports_overview.export_reports': 'Export Reports',
  'page_reports_overview.export_report_tooltip': 'Export report',
  'page_reports_overview.actions': 'Actions',
  'page_reports_overview.export_title_popup': 'Generate reports',
  'page_reports_overview.export_description_popup':
    'Enter the start and end date and give the reports a name.',
  'page_reports_overview.export_warning_message':
    'Warning: this action will reset the Loaded kWhs and Intake dates entered by the customer!',
  'page_reports_overview.export_reports_title_popup': 'Export reports',
  'page_reports_overview.export_reports_description_popup':
    'Select the report name.',
  'page_reports_overview.export_current_report_title_popup':
    'Export selected report',
  'page_reports_overview.export_current_report_description_popup':
    'Please confirm that you want to export the selected report.',
  'page_reports_overview.export_current_report_label': 'Selected report',
  'page_reports_overview.export_current_report_submit': 'Export report',
  'page_reports_overview.export_current_report_disabled_tooltip':
    'This report is still being generated and cannot be exported yet. Wait until the batch is completed.',
  'page_reports_overview.export_reports_placeholder': 'Select report',
  'page_reports_overview.export_reports_search_placeholder':
    'Type to quickly search reports...',
  'page_reports_overview.export_reports_required': 'Please select a report.',
  'page_reports_overview.export_reports_loading': 'Loading reports...',
  'page_reports_overview.export_reports_empty':
    'No reports are available for export.',
  'page_reports_overview.export_report_name_label': 'Report name',
  'page_reports_overview.export_report_name_placeholder': 'Enter report name',
  'page_reports_overview.export_report_name_helper':
    'Maximum 50 characters and use a unique name.',
  'page_reports_overview.export_report_name_required':
    'Report name is required.',
  'page_reports_overview.export_report_name_too_long':
    'Report name cannot exceed 50 characters.',
  'page_reports_overview.export_report_name_checking':
    'Checking report name...',
  'page_reports_overview.export_report_name_exists':
    'This report name already exists.',
  'page_reports_overview.export_report_name_available':
    'This report name is available.',
  'page_reports_overview.export_from_label': 'Start date',
  'page_reports_overview.export_to_label': 'End date',
  'page_reports_overview.export_date_placeholder': 'Select date',
  'page_reports_overview.export_from_required': 'Start date is required.',
  'page_reports_overview.export_to_required': 'End date is required.',
  'page_reports_overview.export_to_after_from':
    'End date must be the same as or later than start date.',
  'page_reports_overview.export_date_future': 'Future dates are not allowed.',
  'page_reports_overview.delete_title_popup':
    'Are you sure you want to delete this report?',
  'page_reports_overview.delete_description_popup':
    'This action is irreversible.',
  'page_reports_overview.deleted_success': 'Report has been deleted.',
  'page_report_show.title': 'Report Details',
  'page_report_show.info_card_title': 'Report Information',
  'page_report_show.report_start_date': 'Report start date',
  'page_report_show.report_end_date': 'Report end date',
  'page_user_overview.delete_user': 'Delete Customer',
  'page_user_overview.delete_user_title_popup':
    'Are you sure you want to delete this customer?',
  'page_user_overview.delete_user_description_popup':
    'This action is irreversible.',
  'page_user_overview.delete_user_successful_title_popup':
    'Customer has been deleted.',
  'page_user_show.show_user_title': 'Show Customer',
  'page_user_show.reset_password_button': 'Reset password',
  'page_user_show.form_last_login': 'Last Login',
  'page_user_show.user_language': 'Customer Display Language',
  'page_user_show.form_verify_email': 'Email Status',
  'page_user_show.info_card_title': 'Customer Information',
  'page_user_show.info_group_card_title': 'Group Information',
  'page_user_show.role_card_title': 'Customer Role',
  'page_user_show.form_created_at': 'Created At',
  'page_user_show.form_updated_at': 'Updated At',
  'page_user_edit.edit_user_title': 'Edit Customer',
  'page_user_edit.form_status': 'Status',
  'page_user_edit.edit_title_popup': 'Customer updated successfully.',
  'page_user_edit.form_language': 'Display Language',
  'page_user_edit.external_user': 'External Customer',
  'page_user_edit.internal_user': 'Internal Customer',
  'page_user_edit.form_user_type': 'Customer Type',
  'page_user_edit.delete_employer': 'Delete account',
  'page_user_edit.delete_customer': 'Delete account',
  'page_user_edit.by_deleting_account':
    'By deleting this account, all your personal information and job data will be permanently deleted and cannot be recovered.',
  'page_user_edit.you_will_not_create_account':
    'You will not be able to create a new account with the email ',
  'page_user_edit.delete_page_title_popup': 'Are you sure you want to do this?',
  'page_user_create.create_user_title': 'Create Customer',
  'page_user_create.create_user_card_information_title': 'Customer Information',
  'page_user_create.create_user_card_group information_title':
    'Group Information',
  'page_user_create.create_user_card_membership_information_title':
    'Membership Information',
  'page_user_create.created_title_popup': 'Customer created successfully.',
  'page_user_create.created_description_popup':
    'An email has been sent for password setup.',
  'page_user_create.form_email': 'Email',
  'page_user_create.credit': 'Credit',
  'page_user_create.form_first_name': 'First Name',
  'page_user_create.form_last_name': 'Last Name',
  'page_user_create.form_status': 'Account Status',
  'page_user_create.company': 'Company',
  'page_user_overview.full_name_user_title_table': 'Full Name',
  'page_user_create.form_information': 'Information',
  'page_user_create.form_phone_number': 'Phone Number',
  'page_user_create.form_role': 'Role',
  'page_user_create.form_select_role': 'Select Role',
  'page_user_create.form_schema_min_email': 'Please enter Email',
  'page_user_create.form_schema_max_email':
    'Email must not be longer than 256 characters.',
  'page_user_create.form_schema_invalid_email': 'Invalid email address',
  'page_user_create.form_schema_gender': 'Please select Gender',
  'page_user_create.form_schema_min_first_name': 'Please enter First Name',
  'page_user_create.form_schema_min_group_name': 'Please enter Group Name',
  'page_user_create.form_schema_min_password':
    'Password must be at least 8 characters',
  'page_user_create.form_schema_max_password': 'Password maximum 64 characters',
  'page_user_create.form_schema_max_first_name':
    'First Name must not be longer than 256 characters.',
  'page_user_create.form_schema_min_last_name': 'Please enter Last Name',
  'page_user_create.form_schema_max_last_name':
    'Last Name must not be longer than 256 characters.',
  'page_user_create.form_schema_max_contact_first_name':
    'Contact first name must not be longer than 256 characters.',
  'page_user_create.form_schema_max_contact_last_name':
    'Contact last name must not be longer than 256 characters.',
  'page_user_create.form_schema_max_contact_email':
    'Contact email must not be longer than 256 characters.',
  'page_user_create.form_schema_max_billing_address':
    'Billing Address must not be longer than 256 characters.',
  'page_user_create.form_schema_max_city':
    'City must not be longer than 256 characters.',
  'page_user_create.form_schema_invalid_phone': 'Invalid phone number',
  'page_user_create.form_schema_role': 'Please select Role',
  'page_user_create.form_schema_group_type': 'Group Type',
  'page_user_create.form_schema_group_name': 'Group Name',
  'page_user_create.form_schema_country_code': 'Country Code',
  'page_user_create.form_schema_company': 'Company',
  'page_user_create.form_schema_street_line_1': 'Street Line 1',
  'page_user_create.form_schema_street_line_2': 'Street Line 2',
  'page_user_create.form_schema_postal_code': 'Postal Code',
  'page_user_create.form_schema_state': 'State',
  'page_user_create.form_schema_phone': 'Phone',
  'page_user_create.form_contact_first_name': 'Contact First Name',
  'page_user_create.form_contact_last_name': 'Contact Last Name',
  'page_user_create.form_contact_email': 'Contact Email',
  'page_user_create.form_billing_address': 'Billing Address',
  'page_user_create.form_street_line_1': 'Street Line 1',
  'page_user_create.form_street_line_2': 'Street Line 2',
  'page_user_create.status': 'Status',
  'page_user_create.form_schema_end_at': 'Expired Date',
  'page_user_create.form_city': 'City',
  'page_user_create.form_schema_group_type_placeholder':
    'Please select group type',
  'page_user_create.form_schema_country_code_placeholder':
    'Please select country code',
  'page_user_create.form_schema_company_placeholder': 'Please select company',
  'page_user_create.form_schema_postal_code_placeholder':
    'Please select postal code',
  'page_user_create.form_schema_state_placeholder': 'Please select state',
  'page_user_create.form_schema_group_type_validation':
    'Please select Group type',
  'page_user_create.form_schema_membership_type': 'Type',
  'page_user_create.form_schema_membership_type_placeholder':
    'Please Select Membership',
  'page_admin_user_overview.users_title': 'Admins',
  'page_admin_user_overview.delete_user': 'Delete Admin',
  'page_admin_user_overview.delete_user_title_popup':
    'Are you sure you want to delete this portal user?',
  'page_admin_user_overview.delete_user_description_popup':
    'This action is irreversible.',
  'page_admin_user_overview.delete_user_successful_title_popup':
    'Admin has been deleted.',
  'page_admin_user_show.show_user_title': 'Show Admin',
  'page_admin_user_show.reset_password_button': 'Reset password',
  'page_admin_user_show.form_last_login': 'Last Login',
  'page_admin_user_show.form_created_at': 'Created At',
  'page_admin_user_show.form_updated_at': 'Updated At',
  'page_admin_user_show.info_card_title': 'Admin Information',
  'page_admin_user_show.role_card_title': 'Admin Role',
  'page_admin_user_edit.edit_user_title': 'Edit Admin',
  'page_admin_user_edit.form_status': 'Status',
  'page_admin_user_edit.edit_title_popup': 'Admin updated successfully.',
  'page_admin_user_edit.profile_title_popup': 'Profile updated successfully.',
  'page_admin_user_create.create_user_title': 'Create Admin',
  'page_admin_user_create.created_title_popup': 'Admin created successfully.',
  'page_admin_user_create.created_description_popup':
    'An email has been sent for password setup.',
  'page_admin_user_create.form_email': 'Email',
  'page_admin_user_create.form_first_name': 'First Name',
  'page_admin_user_create.form_last_name': 'Last Name',
  'page_admin_user_create.form_phone_number': 'Phone Number',
  'page_admin_user_create.form_role': 'Role',
  'page_admin_user_create.form_select_role': 'Select Role',
  'page_admin_user_create.form_schema_min_email': 'Please enter Email',
  'page_admin_user_create.form_schema_max_email':
    'Email must not be longer than 256 characters.',
  'page_admin_user_create.form_schema_invalid_email': 'Invalid email address',
  'page_admin_user_create.form_schema_min_first_name':
    'Please enter First Name',
  'page_admin_user_create.form_schema_max_first_name':
    'First Name must not be longer than 256 characters.',
  'page_admin_user_create.form_schema_min_last_name': 'Please enter Last Name',
  'page_admin_user_create.form_schema_max_last_name':
    'Last Name must not be longer than 256 characters.',
  'page_admin_user_create.form_schema_invalid_phone': 'Invalid phone number',
  'page_admin_user_create.form_schema_role': 'Please select Role',
  'page_admin_user_create.form_schema_company': 'Please select Company',
  'page_contact_create.form_gender': 'Gender',
  'page_contact_create.form_select_gender': 'Select Gender',
  'page_user_create.form_schema_max_pin_code':
    'Pin code must not be longer than 4 characters.',
  'page_role_overview.roles_title': 'Admin Roles',
  'page_role_overview.create_role_button': 'Create',
  'page_role_overview.edit_role_actions': 'Edit Portal Role',
  'page_role_overview.delete_role_actions': 'Delete Portal Role',
  'page_role_overview.role_id_table': 'Role ID',
  'page_role_overview.role_name_table': 'Role Name',
  'page_role_overview.permissions_table': 'Permissions',
  'page_role_overview.last_update_table': 'Last Update',
  'page_role_overview.delete_role_successful_title_popup':
    'Role has been deleted.',
  'page_role_overview.delete_role_title_popup':
    'Are you sure you want to delete this role?',
  'page_role_overview.delete_role_description_popup':
    'This action is irreversible.',
  'page_role_create.create_role_title': 'Create Portal Role',
  'button.cancel': 'Cancel',
  'button.save': 'Save',
  'button.saving': 'Saving',
  'page_role_create.form_name': 'Role Name',
  'button.submit': 'Submit',
  'button.back_to_log_in': 'Back to log in',
  'page_role_create.form_permissions': 'Permissions',
  'page_role_create.form_schema_min_name': 'Please enter Role Name',
  'page_role_create.form_schema_max_name':
    'Name must not be longer than 256 characters.',
  'page_role_create.form_schema_claims':
    'You must select at least one permission',
  'page_role_create.created_title_popup': 'Role created successfully.',
  'page_role_show.roles_show_title': 'Show Portal Role',
  'page_role_show.info_card_title': 'Portal Role Information',
  'page_role_show.users_card_title': 'Portal Role Members',
  'page_role_edit.roles_edit_title': 'Edit Portal Role',
  'page_role_edit.updated_title_popup': 'Portal Role updated successfully.',
  'account.verify.title': 'Email Verified',
  'account.verify_failed.title': 'Email Verified Failed',
  'account.verify.description':
    'Congratulations! You have successfully verified your email.',
  'account.verify.description_failed':
    '          The affiliate link has expired.',
  'account.verify-failed.title': 'Invalid Link',
  'account.verify-failed.description':
    'This link is no longer valid or has already been used.',
  'account.verify-failed.description_sub': 'Please check again or contact us',
  'account.verify-failed.description_link': 'here',
  'page_account_show.return_to_app.information': 'Return to app',
  'page_account_show.go_to_login.information': 'Go to login',
  'page_account_show.back_to_login.information': 'Back to login',
  'auth.login_session_expired': 'Your login session is expired',
  'page_log_overview.logs_title': 'Logs',
  'page_log_overview.id_log_title_table': 'ID',
  'page_log_overview.full_name_title_table': 'Actor',
  'page_log_overview.action_title_table': 'Action',
  'page_log_overview.description_title_table': 'Description',
  'page_log_overview.form_created_at': 'Date Time',
  'page_log_show.show_log_title': 'Show Log',
  'page_log_show.info_card_title': 'Log Information',
  'page_my_profile.title': 'My Account',
  'page_my_profile.description': 'Manage your account information.',
  'page_my_profile.nav-information': 'Profile',
  'page_my_profile.nav-password': 'Password',
  'page_my_profile.nav-credit': 'Credit',
  'page_my_profile.form-title': 'Account Profile',
  'page_my_profile.form-description':
    'This is how others will see you on the site.',
  'page_my_profile.nav-notifications': 'Notifications',
  'page_my_profile.nav-sub-notifications':
    'Manage how and when you receive notifications.',
  'page_my_profile.notifications.backup_emails_label': 'Backup database emails',
  'page_my_profile.notifications.backup_emails_description':
    'Receive notifications about scheduled and completed database backups.',
  'page_my_profile.notifications.contact_emails_label': 'Contact emails',
  'page_my_profile.notifications.contact_emails_description':
    'Receive emails when someone contacts you through the platform.',
  'page_my_profile.notifications.report_emails_label': 'Report emails',
  'page_my_profile.notifications.report_emails_description':
    'Receive emails about reports, flags, and related updates.',
  'page_my_profile.notifications.vacancy_emails_label': 'Vacancy emails',
  'page_my_profile.notifications.vacancy_emails_description':
    'Receive emails about job vacancies, applications, and updates.',
  'page_my_profile.notifications.profile_title_popup':
    'Notifications updated successfully.',
  'permissions_group.system': 'System',
  'permissions_group.user': 'Customers',
  'permissions_group.role': 'Roles',
  'permissions_group.audit-log': 'Logs',
  'permissions_group.admin-user': 'Admins',
  'permissions_group.promotion': 'Vacancy Configurations',
  'permissions_group.review': 'Reviews',
  'permissions_group.profile_avatar': 'Profile Avatars',
  'permissions.SUPER': 'All Permissions',
  'permissions.VIEW_DASHBOARD': 'View Dashboard',
  'permissions.VIEW_USER': 'View Customers',
  'permissions.CREATE_USER': 'Create Customers',
  'permissions.UPDATE_USER': 'Edit Customers',
  'permissions.DELETE_USER': 'Delete Customers',
  'permissions.VIEW_ADMIN_USER': 'View Admins',
  'permissions.CREATE_ADMIN_USER': 'Create Admins',
  'permissions.UPDATE_ADMIN_USER': 'Edit Admins',
  'permissions.DELETE_ADMIN_USER': 'Delete Admins',
  'permissions.VIEW_ROLE': 'View Roles',
  'permissions.CREATE_ROLE': 'Create Roles',
  'permissions.UPDATE_ROLE': 'Edit Roles',
  'permissions.DELETE_ROLE': 'Delete Roles',
  'permissions.VIEW_AUDIT_LOG': 'View Log',
  'permissions.VIEW_PAGE': 'View Page',
  'permissions.CREATE_PAGE': 'Create Page',
  'permissions.UPDATE_PAGE': 'Update Page',
  'permissions.DELETE_PAGE': 'Delete Page',
  'permissions.VIEW_CATEGORY': 'View Category',
  'permissions.CREATE_CATEGORY': 'Create Category',
  'permissions.UPDATE_CATEGORY': 'Update Category',
  'permissions.DELETE_CATEGORY': 'Delete Category',
  'permissions.VIEW_AUTHOR': 'View Author',
  'permissions.CREATE_AUTHOR': 'Create Author',
  'permissions.UPDATE_AUTHOR': 'Update Author',
  'permissions.DELETE_AUTHOR': 'Delete Author',
  'permissions.VIEW_PUBLISHER': 'View Publisher',
  'permissions.CREATE_PUBLISHER': 'Create Publisher',
  'permissions.UPDATE_PUBLISHER': 'Update Publisher',
  'permissions.DELETE_PUBLISHER': 'Delete Publisher',
  'permissions.VIEW_PROMOTION': 'View Promotion',
  'permissions.CREATE_PROMOTION': 'Create Promotion',
  'permissions.UPDATE_PROMOTION': 'Update Promotion',
  'permissions.DELETE_PROMOTION': 'Delete Promotion',
  'permissions.VIEW_REVIEW': 'View Review',
  'permissions.CREATE_REVIEW': 'Create Review',
  'permissions.UPDATE_REVIEW': 'Update Review',
  'permissions.DELETE_REVIEW': 'Delete Review',
  'permissions.VIEW_SETTING': 'View Settings',
  'permissions.UPDATE_SETTING': 'Update Settings',
  'permissions.VIEW_MAIL_LOG': 'View Mail Logs',
  'permissions.VIEW_SECURITY_ALERT': 'View Security Alerts',
  'permissions_group.page': 'Pages',
  'permissions_group.author': 'Authors',
  'permissions_group.category': 'Categories',
  'page_user_create.form_password': 'Password',
  'page_user_create.confirm_password': 'Confirm Password',
  'page_user_create.form_pin_code': 'Pin Code',
  'page_setting.title': 'Settings',
  'page_setting.report_export_toggle_label': 'Enable manual report export',
  'page_setting.security_alert_section_title': 'Security Alert',
  'page_setting.security_alert_emails_label': 'Security Alert Recipients',
  'page_setting.security_alert_emails_placeholder':
    'security@example.com, alerts@example.com',
  'page_setting.security_alert_emails_tooltip':
    'Enter email addresses separated by commas.',
  'page_setting.security_alert_threshold_label':
    'Suspicious Activity Threshold',
  'page_setting.security_alert_threshold_tooltip':
    'If left empty, the default value 5 is used.',
  'page_setting.security_alert_window_seconds_label': 'Time Window (seconds)',
  'page_setting.security_alert_window_seconds_tooltip':
    'If left empty, the default value 15 is used.',
  'permissions_group.tag': 'Tags',
  'permissions.VIEW_TAG': 'View Tags',
  'permissions.CREATE_TAG': 'Create Tags',
  'permissions.UPDATE_TAG': 'Update Tags',
  'permissions.DELETE_TAG': 'Delete Tags',
  'menu.dashboards_title': 'Dashboards',
  'menu.management_title': 'Management',
  'menu.general_title': 'General',
  'menu.system_title': 'System',
  'menu.logs_title': 'Logs',
  'menu.users_title': 'Customers',
  'menu.setting_title': 'Settings',
  'menu.management_title.user': 'Customer Management',
  'menu.management_title.user-configuration': 'Customer Configurations',
  'menu.management_title.user-nav-configurations': 'Configurations',
  'menu.email-log_title': 'Email Logs',
  'menu.security_alert_title': 'Security Alert',
  'menu.management_title.nav-views': 'Views',
  'menu.management_title.nav-applies': 'Applications',
  'menu.management_title.company': 'Company Management',
  'menu.management_title.job': 'Vacancy Management',
  'page_admin_users_overview.title': 'Admins',
  'page_employee_overview.employee_title': 'Employees',
  'option.yes': 'Yes',
  'option.no': 'No',
  'file_upload.file-invalid-type': 'Invalid file type',
  'file_upload.file-too-large': 'The selected file(s) is too large',
  'file_upload.file-too-small': 'The selected file(s) is too small',
  'file_upload.too-many-files': 'Too many files are selected',
  'status.active': 'Active',
  'status.inactive': 'Inactive',
  'status.true': 'Verified',
  'status.false': 'Unverified',
  'breadcrumbs.management': 'Management',
  'breadcrumbs.management.jobs': 'Vacancy Management',
  'breadcrumbs.general': 'General',
  'breadcrumbs.general.users': 'System',
  'breadcrumbs.general.system': 'System',
  'breadcrumbs.management.page': 'Pages Management',
  'membership_type.PREMIUM': 'PREMIUM',
  'membership_type.FREEMIUM': 'Freemium',
  'organization_types.FAMILY': 'FAMILY',
  'organization_types.SCHOOL': 'SCHOOL',
  'pages_management_setting.title': 'Pages Configurations',
  'pages_management_setting.toast_successful_title':
    'Pages configuration updated successfully.',
  'layout.goto': 'Go to customer page',
  'user_management_setting.toast_successful_title':
    'User configurations updated successfully.',
  'error_toast.title': 'Something went wrong',
  'error_toast.description': 'The issue has been reported.',
  'error_toast.error_id': 'Error ID: ',
  'common.time_minute': 'minute',
  'common.time_second': 'second',
  'common.loading': 'Loading',
  'data_table.rows_selected': '{{count}} of {{total}} row(s) selected.',
  'data_table.no_results': 'No results.',
  'data_table.total_items': 'Total {{count}} item(s)',
  'data_table.page_of': 'Page {{page}} of {{total}}',
  'validation.required': 'This field is required.',
  'validation.email.invalid': 'Invalid email address.',
  'validation.email.required': 'Email is required.',
  'validation.password.required': 'Password is required.',
  'validation.password.matched': 'Password do not match.',
  'validation.password.min':
    'Password must be at least {{ min }} characters long',
  'validation.password.reset_token_invalid_title': 'Invalid or Expired Link',
  'validation.password.reset_token_invalid_description':
    'The password reset link is invalid or has expired. Please request a new one.',
  'validation.iban.invalid': 'Invalid IBAN number.',
  'validation.iban.required': 'IBAN number is required.',
  'validation.field.max': 'Maximum length is {{max}} characters.',
  'validation.report_payment_import.file_required':
    'Please upload a valid CSV file.',
  'validation.report_payment_import.file_type': 'Only CSV files are allowed.',
  'validation.report_payment_import.file_max':
    'The file may not be greater than {{max}} KB.',
  'validation.report_payment_import.invalid_structure':
    'The CSV file does not have the expected structure.',
  'page_dashboard.intro': 'Welcome to the Zeres Dashboard.',
  'button.reset': 'Reset',
  'common.total_items': 'Total {{count}} item(s)',
  'common.create': 'Create',
  'common.save': 'Save',
  'common.cancel': 'Cancel',
  'common.close': 'Close',
  'common.delete': 'Delete',
  'common.edit': 'Edit',
  'common.view': 'View',
  'common.import': 'Import',
  'common.confirm': 'Confirm',
  'common.submit': 'Submit',
  'common.search': 'Search',
  'common.search_placeholder': 'Search...',
  'common.error': 'Error',
  'common.success': 'Success',
  'common.back': 'Back',
  'common.next': 'Next',
  'common.previous': 'Previous',
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.ok': 'OK',
  'common.action_irreversible': 'This action is irreversible.',
  'common.are_you_sure': 'Are you sure you want to {{action}}?',
  'common.version': 'Version',
  'column.page_linked': 'Page Linked',
  'column.vacancy_title': 'Vacancy Title',
  'column.location': 'Location',
  'column.created_at': 'Created At',
  'column.last_updated_at': 'Last Updated At',
  'column.job_listing': 'Job Listing',
  'column.note': 'Note',
  'column.errors': 'Errors',
  'column.job_link': 'Job Link',
  'column.job_title': 'Job Title',
  'column.status': 'Status',
  'column.code_id': 'Code ID',
  'column.message': 'Message',
  'column.id': 'ID',
  'column.category': 'Category',
  'column.company': 'Company',
  'column.type': 'Type',
  'column.actions': 'Actions',
  'column.updated_at': 'Updated At',
  'toast.created_successfully': 'Created Successfully',
  'toast.updated_successfully': 'Updated Successfully',
  'toast.deleted_successfully': 'Deleted Successfully',
  'toast.imported_successfully': 'Imported {{count}} Vacancy(s) Successfully',
  'toast.error_submitted_successfully':
    'Error submitted for code regeneration successfully.',
  'tooltip.view_page': 'View Page',
  'tooltip.view_vacancy': 'View Vacancy',
  'tooltip.view_job': 'View Job',
  'tooltip.edit_page': 'Edit Page',
  'tooltip.delete_page': 'Delete Page',
  'tooltip.edit_error': 'Edit Error',
  'tooltip.edit': 'Edit',
  'tooltip.delete': 'Delete',
  'tooltip.not_have_permission': 'You do not have the required permissions',
  'tooltip.not_delete_role_admin': 'This role cannot be deleted',
  'tooltip.not_edit_role_admin': 'This role cannot be edited',
  'form.not_available': 'Not available',
  'form.no_address': 'No Address',
  'form.is_required': 'This field is required',
  'button.delete': 'Delete',
  'button.coming_soon': 'Coming Soon',
  'button.edit': 'Edit',
  'button.back': 'Back',
  'button.upload': 'Upload',
  'button.analyse': 'Analyse',
  'button.create': 'Create',
  'page_job_promotion.settings_website_title': 'Website Name',
  'page_job_promotion.settings_website_meta_keywords': 'Default Meta Keywords',
  'page_job_promotion.settings_website_meta_description':
    'Default Meta Description',
  'page_job_promotion.settings_website_metadata': 'Website Metadata',
  'page_job_promotion.settings_website_logo': 'Logo (Light)',
  'page_job_promotion.settings_website_logo_dark': 'Logo (Dark)',
  'page_job_promotion.settings_website_favicon': 'Favicon',
  'page_job_promotion.settings_save': 'Save',
  'page_job_promotion.settings_updated':
    'Settings Updated. Please reload page again',
  'page_job_promotion.settings_error_logo_upload':
    'Only PNG files are allowed.',
  'page_job_promotion.settings_error_favicon_upload':
    'Only PNG and ICO files are allowed.',
  'menu.management_title.page': 'Pages Management',
  'menu.management_title.nav-page': 'Pages',
  'menu.management_title.nav_page_configuration': 'Pages Configurations',
  'menu.management_title.nav_blog': 'Posts',
  'page_dashboard.title': 'Dashboard',
  'page_dashboard.analytics': 'Analytics',
  'page_dashboard.total_published_jobs': 'Total Published Vacancies',
  'page_dashboard.total_job_views': 'Total Vacancy Views',
  'page_dashboard.total_users_sessions': 'Total Users Sessions',
  'page_dashboard.live_presence_title': 'Admin presence',
  'page_dashboard.live_presence_description':
    'Overview of the admins currently active on Zeres.',
  'page_dashboard.online_count': 'Online admins',
  'page_dashboard.latest_online_users': 'Latest online admins',
  'page_dashboard.online_now': 'Online',
  'page_dashboard.no_online_users': 'No admin users are online right now.',
  'page_dashboard.last_seen_at': 'Last activity',
  'page_dashboard.expires_at': 'Expires at',
  'page_dashboard.user_type_admin': 'Admin',
  'page_dashboard.user_type_customer': 'Customer',
  'page_dashboard.user_type_all': 'All',
  'page_dashboard.customer_presence_title': 'Customer presence',
  'page_dashboard.customer_presence_description':
    'Overview of the customers currently active on Zeres.',
  'page_dashboard.customer_presence_online_count': 'Online customers',
  'page_dashboard.latest_online_customers': 'Latest online customers',
  'page_dashboard.customer_presence_empty':
    'Customer presence is not available yet.',
  'page_dashboard.all_presence_title': 'Users presence',
  'page_dashboard.all_presence_description':
    'Overview of the admins and customers currently active on Zeres.',
  'page_dashboard.latest_online_all_users': 'Latest online users',
  'page_dashboard.all_presence_empty': 'No users are online right now.',
  'page_dashboard.total_jobs_applications': 'Total Vacancies Applications',
  'page_dashboard.jobs_and_applications': 'Views and Applications',
  'page_dashboard.recent_jobs_applications': 'Recent Vacancies Applications',
  'page_dashboard.views_and_applications': 'Views and Applications',
  'page_dashboard.recent_vacancies': 'Recent Vacancies',
  'page_dashboard.total_credits': 'Total Credits',
  'page_dashboard.total_jobs': 'Total Vacancies',
  'page_dashboard.total_views': 'Total Views',
  'page_dashboard.total_applications': 'Total Applications',
  'page_dashboard.purchase_credits': 'Purchase Credits',
  'page_dashboard.a_user_session':
    'A user session is counted when a user enters the AI JOBS website and use the website in 10 minutes.',
  'page_dashboard.after_10_minutes':
    'After 10 minutes, if a user goes back to the website, it will be counted as a new session.',
  'page_page_overview.title': 'Pages',
  'page_page_overview.error_title':
    'Please fill in at least one language (EN or NL)',
  'page_page_overview.delete_page_title_popup':
    'Are you sure you want to delete this Page?',
  'page_page_overview.delete_page_description_popup':
    'This action is irreversible.',
  'page_page_overview.delete_page_successful_title_popup':
    'Page Deleted Successfully',
  'page_page_create.create_page_title': 'Create Page',
  'page_page_create.create_page_information': 'Page Information',
  'page_page_create.create_status': 'Status',
  'page_page_create.seo_title': 'SEO Information',
  'page_page_create.seo_slug': 'Slug',
  'page_page_create.meta_keywords': 'Meta Keywords',
  'page_page_create.meta_description': 'Meta Description',
  'page_page_create.created_title_popup': 'Page Created Successfully',
  'page_page_create.create_position': 'Position',
  'page_page_create.create_order': 'Order',
  'page_page_show.show_page_title': 'Show Page',
  'page_page_show.information': 'Page Information',
  'page_page_show.id': 'ID',
  'page_page_show.status': 'Status',
  'page_page_show.type': 'Type',
  'page_page_show.slug': 'Slug',
  'page_page_show.title': 'Title',
  'page_page_show.meta_description': 'Meta Description',
  'page_page_show.meta_keywords': 'Meta Keywords',
  'page_page_show.seo_information': 'SEO Information',
  'page_page_show.content': 'Page Content',
  'page_page_show.content_label': 'Content',
  'page_page_show.headline': 'Headline',
  'page_page_show.position': 'Position',
  'page_page_show.order': 'Order',
  'page_page_show.template': 'Template',
  'page_page_show.featured_image': 'Featured Image',
  'page_page_edit.edit_page_title': 'Edit Page',
  'page_page_edit.page_information': 'Page Information',
  'page_page_edit.edot_page_status': 'Status',
  'page_page_edit.seo_title': 'SEO Information',
  'page_page_edit.seo_slug': 'Slug',
  'page_page_edit.meta_keywords': 'Meta Keywords',
  'page_page_edit.meta_description': 'Meta Description',
  'page_page_edit.edit_title_popup': 'Page Updated Successfully',
  'page_page_edit.edit_status': 'Status',
  'page_page_edit.edit_position': 'Position',
  'page_page_edit.edit_order': 'Order',
  'page_page_edit.page_type': 'Type',
  'page_page_edit.page_template': 'Template',
  'page_page_edit.featured_image': 'Featured Image',
  'page_blog_overview.title': 'Posts',
  'page_blog_overview.error_title':
    'Please fill in at least one language (EN or NL)',
  'page_blog_overview.delete_page_title_popup':
    'Are you sure you want to delete this post?',
  'page_blog_overview.delete_page_description_popup':
    'This action is irreversible.',
  'page_blog_overview.delete_page_successful_title_popup':
    'Post Deleted Successfully',
  'page_blog_overview.id': 'ID',
  'page_blog_overview.name_en': 'Name (EN)',
  'page_blog_overview.name_nl': 'Name (NL)',
  'page_blog_overview.slug': 'Slug',
  'page_blog_overview.position': 'Position',
  'page_blog_overview.order': 'Order',
  'page_blog_overview.status': 'Status',
  'page_blog_overview.actions': 'Actions',
  'page_blog_create.create_page_title': 'Create Post',
  'page_blog_create.create_page_information': 'Post Information',
  'page_blog_create.create_status': 'Status',
  'page_blog_create.seo_title': 'SEO Information',
  'page_blog_create.seo_slug': 'Slug',
  'page_blog_create.meta_keywords': 'Meta Keywords',
  'page_blog_create.meta_description': 'Meta Description',
  'page_blog_create.created_title_popup': 'Post Created Successfully',
  'page_blog_show.show_page_title': 'Show Post',
  'page_blog_show.information': 'Post Information',
  'page_blog_show.id': 'ID',
  'page_blog_show.status': 'Status',
  'page_blog_show.slug': 'Slug',
  'page_blog_show.title': 'Title',
  'page_blog_show.meta_description': 'Meta Description',
  'page_blog_show.meta_keywords': 'Meta Keywords',
  'page_blog_show.seo_information': 'SEO Information',
  'page_blog_show.content': 'Post Content',
  'page_blog_show.content_label': 'Content',
  'page_blog_show.headline': 'Headline',
  'page_blog_show.template': 'Template',
  'page_blog_show.featured_image': 'Featured Image',
  'page_blog_edit.edit_page_title': 'Edit Post',
  'page_blog_edit.page_information': 'Post Information',
  'page_blog_edit.edot_page_status': 'Status',
  'page_blog_edit.seo_title': 'SEO Information',
  'page_blog_edit.seo_slug': 'Slug',
  'page_blog_edit.meta_keywords': 'Meta Keywords',
  'page_blog_edit.meta_description': 'Meta Description',
  'page_blog_edit.edit_title_popup': 'Post Updated Successfully',
  'page_blog_edit.edit_status': 'Status',
  'page_blog_edit.page_template': 'Template',
  'page_blog_edit.featured_image': 'Featured Image',
  'page_email_logs.title': 'Email Logs',
  'page_email_logs.id': 'ID',
  'page_email_logs.subject': 'Subject',
  'page_email_logs.to': 'To',
  'page_email_logs.status': 'Status',
  'page_email_logs.created_at': 'Sent At',
  'page_email_logs.actions': 'Actions',
  'page_security_alert.title': 'Security Alerts',
  'page_security_alert.id': 'ID',
  'page_security_alert.event_type': 'Event Type',
  'page_security_alert.email': 'Email',
  'page_security_alert.ip_address': 'IP Address',
  'page_security_alert.user_agent': 'User Agent',
  'page_security_alert.route': 'API endpoint',
  'page_security_alert.method': 'Method',
  'page_security_alert.created_at': 'Created At',
  'page_security_alert.event_types.permission_denied': 'Permission Denied',
  'page_security_alert.event_types.brute_force_detected':
    'Brute Force Detected',
  'page_mail_log.title': 'Email Log',
  'page_mail_log.card_title': 'Email Log Information',
  'page_mail_log.id': 'ID',
  'page_mail_log.sender': 'Sender',
  'page_mail_log.subject': 'Subject',
  'page_mail_log.receiver': 'To',
  'page_mail_log.status': 'Status',
  'page_mail_log.created_at': 'Sent At',
  'page_mail_log.message': 'Message',
  'page_mail_log.content': 'Mail Content',
  'page_mail_log.status.sent': 'Sent',
  'page_mail_log.status.failed': 'Failed',
  'page_page_overview.id': 'ID',
  'page_page_overview.name_en': 'Name (EN)',
  'page_page_overview.name_nl': 'Name (NL)',
  'page_page_overview.slug': 'Slug',
  'page_page_overview.position': 'Position',
  'page_page_overview.order': 'Order',
  'page_page_overview.status': 'Status',
  'page_page_overview.actions': 'Actions',
  'page_role_overview.id': 'ID',
  'page_role_overview.actions': 'Actions',
  'page_role_show.id': 'User ID',
  'page_role_show.full_name': 'Full Name',
  'page_role_show.email': 'Email',
  'page_role_show.actions': 'Actions',
  'page_admin_user_overview.title': 'Admin Users',
  'page_admin_user_overview.id': 'ID',
  'page_admin_user_overview.full_name': 'Full Name',
  'page_admin_user_overview.email': 'Email',
  'page_admin_user_overview.role': 'Role',
  'page_admin_user_overview.actions': 'Actions',
  'page_customer_job_listing.id': 'ID',
  'page_customer_job_listing.name': 'Name',
  'page_customer_job_listing.address': 'Address',
  'page_customer_job_listing.expired_date': 'Expired Date',
  'page_customer_job_listing.status': 'Status',
  'page_customer_job_listing.type': 'Type',
  'page_customer_job_listing.category': 'Category',
  'page_customer_job_listing.salary': 'Salary',
  'page_customer_job_listing.updated_by': 'Updated By',
  'page_customer_job_listing.applications': 'Applications',
  'page_customer_job_listing.views': 'Views',
  'page_customer_job_listing.actions': 'Actions',
  'page_customer_overview.stations_title': 'Charging Stations',
  'page_customer_create.documentation': 'Documentation',
  'page_transaction_columns.id': 'ID',
  'page_transaction_columns.customer': 'Customer',
  'page_transaction_columns.payment_date': 'Payment Date',
  'page_transaction_columns.reference_id': 'Reference ID',
  'page_transaction_columns.type': 'Type',
  'page_transaction_columns.amount': 'Amount',
  'page_transaction_columns.discount_amount': 'Discount Amount',
  'page_transaction_columns.promo_code': 'Promo Code',
  'page_transaction_columns.status': 'Status',
  'page_transaction_columns.actions': 'Actions',
  'page_audit_logs.title': 'Audit Logs',
  'page_audit_logs.id': 'ID',
  'page_audit_logs.causer_name': 'Actor',
  'page_audit_logs.event': 'Event',
  'page_audit_logs.description': 'Description',
  'page_audit_logs.created_at': 'Created At',
  'page_audit_logs.actions': 'Actions',
  'Customer self-registration': 'Customer self-registration',
  'System process': 'System process',
  'page_my_profile.form_first_name': 'First Name',
  'page_my_profile.form_first_name_placeholder': 'First Name',
  'page_my_profile.form_last_name': 'Last Name',
  'page_my_profile.form_last_name_placeholder': 'Last Name',
  'page_my_profile.form_email': 'Email',
  'page_my_profile.form_email_placeholder': 'test@example.com',
  'page_my_profile.form_phone_number': 'Phone Number',
  'page_my_profile.form_phone_number_placeholder': 'Phone Number',
  'page_my_profile.form_language': 'Display Language',
  'page_my_profile.select_language': 'Select Language',
  'page_customer_profile.select_customer_language': 'Select Customer Language',
  'page_company_edit.general_information': 'General Information',
  'page_company_edit.career_page': 'Career Page',
  'page_company_edit.extra_information': 'Extra Information',
  'page_company_edit.company_address': 'Company Address',
  'page_company_edit.enter_company_address': 'Enter Company Address',
  'page_company_edit.find_location': 'Find Location',
  'page_company_edit.address_description':
    'Enter the address of your company, then click "Find Location" to update the location of your company.',
  'page_login.portal_label': 'Admin Portal',
  'page_login.title': 'Log In',
  'page_login.description': 'Enter your email and password to log in',
  'page_login.email_label': 'Email',
  'page_login.email_placeholder': 'name@example.com',
  'page_login.password_label': 'Password',
  'page_login.password_placeholder': '********',
  'page_login.captcha_label': 'Captcha',
  'page_login.captcha_placeholder': 'Enter the captcha',
  'page_login.captcha_refresh': 'Refresh',
  'page_login.captcha_required': 'Please complete the captcha challenge.',
  'page_login.captcha_loading': 'Captcha loading...',
  'page_login.captcha_load_failed': 'Failed to load captcha. Please try again.',
  'page_login.security_load_failed':
    'Failed to load login security. Please try again.',
  'page_login.sign_in': 'Sign in',
  'page_login.forgot_password_link': 'I forgot my password',
  'page_forgot_password.title': 'Forgot Password',
  'page_forgot_password.description': 'Enter your email to reset your password',
  'page_forgot_password.email_label': 'Email',
  'page_forgot_password.email_placeholder': 'name@example.com',
  'page_forgot_password.toast_title':
    'Your request to reset password has been submitted successfully.',
  'page_forgot_password.toast_description':
    'Please check your email for further instructions.',
  'page_job_create.all_required': '(All * is required)',
  'page_job_create.level_label': 'Level',
  'page_job_create.level_placeholder': 'Enter job level',
  'page_job_create.job_description': 'Job Description',
  'page_job_create.address_information': 'Address Information',
  'page_job_create.address_line_1': 'Address Line 1',
  'page_job_create.address_line_2': 'Address Line 2',
  'page_job_create.city_country': 'City - Country',
  'page_job_create.state_province_region': 'State/Province/Region',
  'page_job_create.zip_postal_code': 'ZIP/Postal Code',
  'page_job_create.find_location': 'Find Location',
  'page_job_create.latitude': 'Latitude',
  'page_job_create.enter_latitude': 'Enter Latitude',
  'page_job_create.latitude_description': 'Latitude (from -90 to 90)',
  'page_job_create.longitude': 'Longitude',
  'page_job_create.enter_longitude': 'Enter Longitude',
  'page_job_create.longitude_description': 'Longitude (from -180 to 180)',
  'page_job_create.auto_generate': 'Leave empty to auto-generate',
  'page_login_customer.customer_portal': 'Customer Portal',
  'page_login_customer.enter_credentials':
    'Enter your email and password to log in',
  'page_login_customer.email': 'Email',
  'page_login_customer.email_placeholder': 'email@example.com',
  'page_login_customer.password': 'Password',
  'page_login_customer.password_placeholder': '********',
  'page_login_customer.sign_in': 'Sign in',
  'page_login_customer.or': 'OR',
  'page_login_customer.sign_in_google': 'Sign in with Google',
  'page_login_customer.no_account': 'Do not have an account?',
  'page_login_customer.sign_up_now': 'Sign up now!',
  'page_login_customer.background_alt': 'Customer portal background',
  'page_login_customer.logo_alt': 'Zeres logo',
  'page_login_customer.forgot_description':
    'Enter your email to receive a reset code',
  'page_login_customer.reset_description':
    'Enter reset code and set your new password',
  'page_login_customer.forgot_password': 'Forgot password',
  'page_login_customer.send_reset_code': 'Send reset code',
  'page_login_customer.back_to_sign_in': 'Back to sign in',
  'page_login_customer.reset_code': 'Reset code',
  'page_login_customer.reset_code_placeholder': 'Enter reset code',
  'page_login_customer.new_password_placeholder': 'Enter new password',
  'page_login_customer.confirm_password': 'Confirm password',
  'page_login_customer.confirm_password_placeholder': 'Confirm new password',
  'page_login_customer.reset_password_button': 'Reset password',
  'page_login_customer.validation_invalid_email': 'Invalid email address',
  'page_login_customer.validation_reset_code_required':
    'Reset code is required',
  'page_login_customer.validation_password_min':
    'Password must be at least 8 characters',
  'page_login_customer.validation_confirm_password_required':
    'Please confirm your password',
  'page_login_customer.validation_passwords_not_match':
    'Passwords do not match',
  'page_register_successful.title': 'Registration successful!',
  'page_register_successful.verification_sent':
    'A verification email has been sent to your registered email address. Please follow the instructions in the email to verify your account.',
  'page_register_successful.check_spam':
    "If you don't see the email, check your Spam folder or contact us",
  'page_register_successful.here': 'here',
  'page_register_successful.back_to_login': 'Back to login',
  'page_register.customer_portal': 'Customer Portal',
  'page_register.create_account': 'Create your account to get started',
  'page_register.sign_up_google': 'Sign up with Google',
  'page_register.or': 'OR',
  'page_register.first_name': 'First name',
  'page_register.last_name': 'Last name',
  'page_register.email': 'Email',
  'page_register.password': 'Password',
  'page_register.confirmation_password': 'Confirmation password',
  'page_register.display_language': 'Display Language',
  'page_register.select_language': 'Select Language',
  'page_register.registering': 'Registering...',
  'page_register.register': 'Register',
  'page_register.already_account': 'Already have an account?',
  'page_register.sign_in': 'Sign in',
  'password_validation.min_length': 'At least 8 characters',
  'password_validation.has_number': 'At least 1 number',
  'password_validation.has_lowercase': 'At least 1 lowercase letter',
  'password_validation.has_uppercase': 'At least 1 uppercase letter',
  'password_validation.has_special': 'At least 1 special character',
  'page_customer_job_show.unpublish_job_success':
    'Unpublish job(s) successfully.',
  'page_customer_job_show.publish_job_success': 'Publish job(s) successfully.',
  'page_customer_job_show.unpublish_confirmation':
    'This action will unpublish the current job to the system',
  'page_customer_job_show.publish_confirmation_title':
    'Are you sure you want to publish job?',
  'page_customer_job_show.publish_description':
    'After publishing, if job(s) have location, it will be displayed on the map.',
  'page_customer_job_show.publish': 'Publish',
  'page_customer_job_show.level': 'Level',
  'page_customer_job_show.applications': 'Applications',
  'page_customer_job_show.views': 'Views',
  'page_customer_job_show.address_information': 'Address Information',
  'page_customer_job_show.city': 'City',
  'page_customer_job_show.job_address': 'Job Address',
  'page_customer_job_show.state_province_region': 'State/Province/Region',
  'page_customer_job_show.zip_postal_code': 'ZIP/Postal Code',
  'page_customer_job_show.latitude': 'Latitude',
  'page_customer_job_show.longitude': 'Longitude',
  'page_setting.logo_tooltip':
    'Logo must be in PNG, WEBP format and no larger than 1MB.',
  'page_setting.favicon_tooltip':
    'Favicon must be in PNG, ICO or WEBP format and no larger than 500kb.',
  'page_setting.report_compensation_percentage_label':
    'Report compensation percentage (%)',
  'page_setting.zeres_commission_label': 'Zeres commission',
  'breadcrumbs.management.users': 'Customer Management',
  'table.id': 'ID',
  'table.brand': 'Brand',
  'table.model': 'Model',
  'table.evse_id': 'Serial number',
  'table.start_date': 'Start Date',
  'table.end_date': 'End Date',
  'table.total_kwh': 'Total (Kwh)',
  'table.actions': 'Actions',
  'table.customer': 'Customer',
  'page_customer_overview.id': 'ID',
  'page_customer_overview.full_name': 'Full Name',
  'page_customer_overview.email': 'Email',
  'page_customer_overview.station_brand_model': 'Brand / Model',
  'page_customer_overview.station_evse_id': 'Serial number',
  'page_customer_overview.control': 'Control',
  'page_customer_overview.partnercode': 'Partner Code',
  'page_customer_overview.registered_date': 'Registered Date',
  'page_customer_overview.account_status': 'Account Status',
  'page_customer_overview.company': 'Company',
  'page_customer_overview.external_user': 'External User',
  'page_customer_overview.actions': 'Actions',
  'page_customer_overview.import_button': 'Import Clients',
  'page_customer_overview.import_dialog_title': 'Import Clients',
  'page_customer_overview.import_dialog_description':
    'Upload a CSV file to import clients.',
  'page_customer_overview.import_choose_file': 'Choose file',
  'page_customer_overview.import_no_file_selected': 'No file selected',
  'page_customer_overview.import_max_file_size': 'Maximum file size: 5MB.',
  'page_customer_overview.import_invalid_file':
    'The CSV file does not have the expected structure.',
  'page_customer_overview.import_sample_file_helper': 'Need a sample file?',
  'page_customer_overview.import_sample_file_download': 'Download sample file',
  'page_customer_overview.import_submit_button': 'Import',
  'page_customer_overview.import_success_title': 'Import request accepted',
  'page_customer_overview.import_success_description':
    'Customer import request has been accepted.',
  'page_customer_overview.import_warning_title': 'Import unavailable',
  'page_customer_overview.import_warning_in_progress':
    'Customer import is already in progress. Please wait until it is completed. You can track the progress in Importlog.',
  'page_customer_overview.import_warning_cooldown':
    'Customer import has just completed. Please wait {{ remaining_time }} before starting a new import.',
  'page_customer_overview.export_button': 'Export Clients',
  'page_customer_overview.export_warning_title': 'Export unavailable',
  'page_customer_overview.export_warning_in_progress':
    'Customer export is already in progress. Please wait until it is completed.',
  'page_customer_overview.export_warning_cooldown':
    'Customer export has just completed. Please wait {{ remaining_time }} before starting a new export.',
  'page_customer_overview.export_success_title':
    'the exporting process is start',
  'page_customer_overview.export_success_description':
    'You can navigate to Customer Export Log page to see the progress and download file once it is done.',
  'page_customer_overview.delete_button': 'Delete All',
  'page_customer_overview.delete_all_success_title':
    'Delete all clients successfully.',
  'page_customer_overview.delete_all_title': 'Delete All Clients',
  'page_customer_overview.delete_all_description':
    'Are you sure you want to delete all clients?. This action to be delete all clients, charging stations and reports for all clients.',
  'page_customer_create.phone_number': 'Phone Number',
  'page_customer_create.street': 'Street',
  'page_customer_create.house_number': 'House Number',
  'page_customer_create.post_code': 'Post Code',
  'page_customer_create.place': 'Place',
  'page_customer_create.account_holder_name': 'Account Holder Name',
  'page_customer_create.ean_number': 'EAN Number',
  'page_customer_create.comments': 'Comments',
  'page_user_create.extra_information_title': 'Extra Information',
  'page_user_create.zeres_commission': 'Zeres Commission',
  'page_user_create.customer_discount_percentage':
    'Customer Discount Percentage',
  'page_user_create.partner_discount_code': 'Partner Discount Code',
  'page_user_create.estimated_yearly_kwh': 'Estimated Yearly Kwh',
  'page_user_create.partner_percentage': 'Partner Percentage',
  'page_customer_create.mid_control': 'Control',
  'page_customer_create.control_performed_at': 'Control Performed At',
  'page_customer_create.control_performed_by': 'Control Performed By',
  'page_user_show.extra_information_title': 'Extra Information',
  'page_reports_overview.created_at': 'Report date',
  'page_reports_overview.start_date': 'Start Date',
  'page_reports_overview.end_date': 'End Date',
  'page_reports_overview.compensation': 'Revenue',
  'page_reports_show.total_kwh': 'Total Kwh',
  'page_report_show.calculated_eres': 'Calculated Eres',
  'page_report_show.booked_eres': 'Booked EREs',
  'page_report_show.revenue': 'Revenue',
  'page_report_show.payment': 'Payment',
  'page_report_show.general_information': 'General Information',
  'page_report_show.station': 'Charging Station',
  'page_report_show.name': 'Name',
  'page_report_show.address': 'Address',
  'page_report_show.phone_number': 'Phone Number',
  'page_report_show.ean_18_number': 'EAN 18 Number',
  'page_report_show.account_holder_name': 'Account Holder Name',
  'page_report_show.iban_number': 'IBAN Number',
  'page_report_show.comments': 'Comments',
  'page_report_show.photos': 'Photos',
  'page_report_show.discard_changes_title': 'Discard changes?',
  'page_report_show.discard_changes_description':
    'You have unsaved changes in this charging station. Do you want to discard them?',
  'page_report_show.discard': 'Discard',
  'page_stations_overview.title': 'Charging Stations',
  'page_stations_overview.button.create': 'Create',
  'page_stations_overview.delete_station_title_popup':
    'Are you sure you want to delete this portal station?',
  'page_stations_overview.delete_station_description_popup':
    'This action is irreversible.',
  'page_stations_overview.delete_station_successful_title_popup':
    'Station has been deleted.',
  'page_stations_show.title': 'Station Detail',
  'page_stations_show.customer': 'Customer',
  'page_stations_show.brand': 'Brand',
  'page_stations_show.model': 'Model',
  'page_stations_show.evse_id': 'Serial number',
  'page_stations_show.start_date': 'Start Date',
  'page_stations_show.end_date': 'End Date',
  'page_stations_show.start_kwh': 'Start (Kwh)',
  'page_stations_show.end_kwh': 'End (Kwh)',
  'page_stations_show.total_kwh': 'Total (Kwh)',
  'page_station_brand_ranking.title': 'Brand details',
  'page_station_brand_ranking.description':
    'Charging stations grouped by brand.',
  'page_station_brand_ranking.email': 'Email',
  'page_station_brand_ranking.model': 'Model',
  'page_station_brand_ranking.evse_id': 'Serial number',
  'page_station_brand_ranking.total_kwh': 'Charged kWh',
  'page_station_brand_ranking.missing_brand': 'Brand is missing.',
  'page_station_brand_ranking.open_customer_detail': 'Open customer detail',
  'page_stations_show.registration_date': 'Registration Date',
  'page_report_show.registration_date': 'Registration Date',
  'page_stations_show.created_at': 'Created At',
  'page_stations_show.updated_at': 'Updated At',
  'page_stations_show.button.delete': 'Delete',
  'page_stations_show.button.back': 'Back',
  'page_stations_show.button.edit': 'Edit',
  'page_stations_edit.title': 'Edit Station',
  'page_stations_edit.customer': 'Customer',
  'page_stations_edit.brand': 'Brand',
  'page_stations_edit.model': 'Model',
  'page_stations_edit.evse_id': 'Serial number',
  'page_stations_edit.start_date': 'Start Date',
  'page_stations_edit.end_date': 'End Date',
  'page_stations_edit.start_kwh': 'Start (Kwh)',
  'page_stations_edit.end_kwh': 'End (Kwh)',
  'page_stations_edit.total_kwh': 'Total (Kwh)',
  'page_stations_edit.created_at': 'Created At',
  'page_stations_edit.updated_at': 'Updated At',
  'page_stations_edit.button.save': 'Save',
  'page_stations_edit.information_alert':
    'Enter the total volume directly (below in the field ‘Charged kWh’) or enter the meter readings below (with date and meter value).',
  'page_stations_edit.warning_alert':
    'The total volume ({{ total }} kWh) does not match the meter readings ({{ calculated }} kWh).',
  'page_stations_create.title': 'Create Station',
  'page_stations_create.customer': 'Customer',
  'page_stations_create.brand': 'Brand',
  'page_stations_create.model': 'Model',
  'page_stations_create.evse_id': 'Serial number',
  'page_stations_create.start_date': 'Start Date',
  'page_stations_create.end_date': 'End Date',
  'page_stations_create.start_kwh': 'Start (Kwh)',
  'page_stations_create.end_kwh': 'End (Kwh)',
  'page_stations_create.total_kwh': 'Total (Kwh)',
  'page_stations_create.created_at': 'Created At',
  'page_stations_create.updated_at': 'Updated At',
  'page_stations_create.button.save': 'Save',
  'page_stations_create.information_alert':
    'Enter the total volume directly (below in the field ‘Charged kWh’) or enter the meter readings below (with date and meter value).',
  'page_stations_create.warning_alert':
    'The total volume ({{ total }} kWh) does not match the meter readings ({{ calculated }} kWh).',
  'page_charging_stations.evse_id': 'Serial number',
  'page_reports_overview.export_queued_success':
    'Generate request has been queued successfully.',
  'page_reports_overview.export_queued_failed':
    'Failed to queue generate request.',
  'page_reports_overview.generate_warning_title': 'Generate unavailable',
  'page_reports_overview.generate_warning_in_progress':
    'Report generation is already in progress. Please wait until it is completed.',
  'page_reports_overview.generate_warning_cooldown':
    'Report generation has just completed. Please wait {{ remaining_time }} before starting a new generation.',
  'page_reports_overview.export_reports_queued_success':
    'Export request has been queued successfully.',
  'page_reports_overview.export_reports_queued_failed':
    'Failed to queue export request.',
  'page_reports_overview.export_reports_success_title':
    'The export process has started',
  'page_reports_overview.export_reports_success_description':
    'Go to the customer export log page to view the progress and download the file once it is ready.',
  'page_reports_overview.export_reports_warning_title': 'Export unavailable',
  'page_reports_overview.export_reports_warning_in_progress':
    'The report export is already in progress. Please wait until it is completed. You can view the progress in Exportlog.',
  'page_reports_overview.export_reports_warning_cooldown':
    'The report export has just completed. Please wait {{ remaining_time }} before starting a new export. You can view the latest progress in Exportlog.',
  'page_reports_overview.import_payments_button': 'Import payments',
  'page_reports_overview.import_payments_title': 'Import payments',
  'page_reports_overview.import_payments_description':
    'Upload a CSV file with the columns Klant ID, Rapport ID, Volume, Ingeboekt, Opbrengst, Betaling and Betaaldatum.',
  'page_reports_overview.import_payments_submit': 'Import',
  'page_reports_overview.import_payments_helper':
    'Only CSV files with the exact expected columns are accepted.',
  'page_reports_overview.import_payments_choose_file': 'Choose file',
  'page_reports_overview.import_payments_no_file_selected': 'No file selected',
  'page_reports_overview.import_payments_required':
    'Select a CSV file before importing.',
  'page_reports_overview.import_payments_invalid_file':
    'The CSV file does not have the expected structure.',
  'page_reports_overview.import_payments_success_title':
    'Payment import has started',
  'page_reports_overview.import_payments_success_description':
    'The file has been queued for processing. You can track the progress in Importlog.',
  'page_reports_overview.import_payments_queued_message':
    'The file has been queued for processing. You can track the progress in Importlog.',
  'page_reports_overview.import_payments_warning_title': 'Import unavailable',
  'page_reports_overview.import_payments_warning_in_progress':
    'The payment import is already in progress. Please wait until it is completed. You can track the progress in Importlog.',
  'page_reports_overview.import_payments_warning_cooldown':
    'The payment import has just completed. Please wait {{ remaining_time }} before starting a new import. You can track the latest progress in Importlog.',
  'page_history_overview.title': 'Importlog',
  'page_history.button.back': 'Back',
  'page_history.button.delete': 'Delete',
  'page_history_overview.id': 'ID',
  'page_history_overview.file_process': 'File Process',
  'page_history_overview.type': 'Type',
  'page_history_overview.type_customer': 'Customers',
  'page_history_overview.type_payment': 'Payments',
  'page_history_overview.total_items': 'Total Items',
  'page_history_overview.proceed_items': 'Proceed Items',
  'page_history_overview.created_clients': 'Clients Created',
  'page_history_overview.created_at': 'Created At',
  'page_history.title': 'Importlog',
  'page_history_overview.process': 'Process Percentage',
  'page_history_item.title': 'Importlog Detail',
  'page_history_item.row_number': 'XLS Row Number',
  'page_history_item.email': 'Email',
  'page_history_item.metadata': 'Metadata',
  'page_history_item.metadata_compensation': 'Revenue',
  'page_history_item.metadata_payment': 'Payment',
  'page_history_item.metadata_payment_date': 'Payment date',
  'page_history_item.status': 'Status',
  'page_history_item.failed_reason': 'Failed Reason',
  'page_customer_export_history.title': 'Customer Export Log',
  'page_customer_export_history.id': 'ID',
  'page_customer_export_history.type': 'Type',
  'page_customer_export_history.type_customer': 'Customers',
  'page_customer_export_history.type_report': 'Reports',
  'page_customer_export_history.exported_by': 'By',
  'page_customer_export_history.file_path': 'File Path',
  'page_customer_export_history.total_items': 'Total Customers',
  'page_customer_export_history.proceed_items': 'Processed Customers',
  'page_customer_export_history.status': 'Status',
  'page_customer_export_history.status_in_progress': 'In Progress',
  'page_customer_export_history.status_failed': 'Failed',
  'page_customer_export_history.status_completed': 'Completed',
  'page_customer_export_history.process': 'Progress',
  'page_customer_export_history.actions': 'Action',
  'page_customer_export_history.download': 'Download',
  'page_customer_export_history.deleted_success':
    'Export history deleted successfully.',
  'page_customer_export_history.delete_title_popup':
    'Are you sure you want to delete this export history?',
  'page_customer_export_history.delete_description_popup':
    'This will permanently delete the history record and stored export file.',
  'page_customer_export_history.created_at': 'Created At',
  "Enter the volume of charging current for the entire period: you can see this, among other places, in your charging station's App or on a report. You can also enter the difference between a start and end reading":
    "Enter the volume of charging current for the entire period: you can see this, among other places, in your charging station's App or on a report. You can also enter the difference between a start and end reading",

  'page_tags_overview.title': 'Tags',
  'page_tags_overview.created_at': 'Created At',
  'page_tags_overview.updated_at': 'Updated At',
  'page_tags_overview.button.delete': 'Delete',
  'page_tags_overview.button.back': 'Back',
  'page_tags_overview.button.edit': 'Edit',
  'page_tags_edit.title': 'Edit Tag',
  'page_tags_edit.created_at': 'Created At',
  'page_tags_edit.updated_at': 'Updated At',
  'page_tags_edit.button.save': 'Save',
  'page_tags_create.title': 'Create Tag',
  'page_tags_create.created_at': 'Created At',
  'page_tags_create.updated_at': 'Updated At',
  'page_tags_create.button.save': 'Save',
  'page_tags_overview.name': 'Name',
  'page_tags_update.title': 'Update Tag',
  'page_tags_overview.delete_title_popup':
    'Are you sure you want to delete this tag?',
  'page_tags_overview.delete_description_popup': 'This action is irreversible.',
  'page_tag_overview.toast_successful_description': 'Tag has been deleted.',
  'page_tag_overview.helper_text_tooltip':
    'Press Tab or Enter to add new tags. You can also create multiple tags using semicolons.',
  'Enter the total number of kilowatt-hours (kWh) charged for this period.':
    'Enter the total number of kilowatt-hours (kWh) charged for this period.',
  'Enter the total number of kilowatt-hours (kWh) charged for this quarter and the recording date. You can find the total number of kilowatt-hours charged in your charging station app or in a report. If you do not have this data but have recorded the meter reading for this quarter, enter the difference between the start and end readings.':
    'Enter the total number of kilowatt-hours (kWh) charged for this quarter and the recording date. You can find the total number of kilowatt-hours charged in your charging station app or in a report. If you do not have this data but have recorded the meter reading for this quarter, enter the difference between the start and end readings.',
  'Charging stations help label charged kwh': 'Charged kWh:',
  'Charging stations help value charged kwh':
    'state the total charging volume for this charging station at the end of the quarter, so at the end of June or the beginning of July. This concerns the total charged electricity in this period.',
  'Charging stations help label where to find it': 'Where to find it:',
  'Charging stations help value where to find it':
    'you can find the total charged electricity in the charging station app or in a report. Do not fill in a meter reading and do not use decimals.',
  'Charging stations help label period': 'Which period:',
  'Charging stations help value period':
    'the period starts from the previous recording date or from January 1, 2026 if no earlier submission has been made.',
  'Charging stations help label proof': 'Proof:',
  'Charging stations help value proof':
    'you can now upload screenshots in the portal showing the charging volume and the period.',
  'Charging stations help label automatic': 'Automatic:',
  'Charging stations help value automatic':
    'we connect your charging station, where possible, to our platform to read the charging volume automatically. After registration, you will receive a message specific to your charging station brand.',
  'Charged kWh': 'Charged kWh',
  Since: 'Since',
  'Total volume (kWh)': 'Charged kWh',
  'Invalid EAN-18 number': 'Invalid EAN-18 number',
  'Check the EAN-18 number': 'Check the EAN-18 number',
  'page_dashboard.select_date': 'Select date',
  'page_dashboard.registered_customers_title': 'Registered Customers',
  'page_dashboard.registered_customers_description':
    'New customer registrations over the selected period.',
  'page_dashboard.total_registered_customers':
    'Total registered customers all time',
  'page_dashboard.new_registered_customers': 'New registered customers:',
  'page_dashboard.registered_customers_footer_day':
    'Showing registered customers per hour',
  'page_dashboard.registered_customers_footer_week_month':
    'Showing registered customers per day',
  'page_dashboard.charging_station_brands_title': 'Top 20 Charging Stations',
  'page_dashboard.charging_station_brands_description':
    'Live ranking of charging stations by current total kWh.',
  'page_dashboard.charging_station_brands_empty': 'No charging stations found.',
  'page_dashboard.charging_station_brands_footer':
    'Showing the top 20 stations by current total kWh.',
  'page_dashboard.analytics_title': 'Online Users Monitor',
  'page_dashboard.analytics_description':
    'Data is updated every 5 minutes. Reload the chart to see the latest values.',
  'page_dashboard.analytics_footer': 'Showing online users per hour',
  'page_dashboard.loading_chart': 'Loading chart...',
  'page_dashboard.reload_analytics': 'Reload chart',
  'page_dashboard.online_users_series': 'Online users:',
  'page_dashboard.time_mode': 'Time Mode',
  'page_dashboard.time_mode_day': 'Day',
  'page_dashboard.time_mode_week': 'Week',
  'page_dashboard.time_mode_month': 'Month',
  'page_dashboard.analytics_footer_day': 'Showing online users per hour',
  'page_dashboard.analytics_footer_week_month': 'Showing online users per day',
  'page_dashboard.view_brand_details': 'View brand details',

  'page_mid_overview.import_logic_title': 'Import logic:',

  'page_mid_overview.import_logic_existing':
    'If Brand and Model already exist, the MID status, Source, and Explanation are updated.',

  'page_mid_overview.import_logic_new':
    'If Brand and Model do not yet exist, a new row is added. Existing rows are not removed.',

  'page_mid_overview.import_logic_matching':
    'Capitalization and leading or trailing spaces are ignored. Minor differences in Brand or Model are treated as a new combination.',

  'page_mid_overview.import_logic_stations':
    'Existing customer charging stations are not updated automatically. The MID status changes only when the charging station is saved again.'
}
